import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Equipamento } from './equipamento.model';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ProdutoFilter } from '../produto/produto.filter';


export interface EquipamentoFilter extends ProdutoFilter {
  numeroSerie?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService extends DefaultService<Equipamento> {

    constructor(
          public httpClient: HttpClient,
          public errorHandler: ErrorHandlerService
    ) {
      super(
        httpClient,
        errorHandler,
        '/api/produto/v1/equipamentos'
      );
    }
}

